
import React from 'react';

const defaultVal = {}
const WorkspaceContext = React.createContext(defaultVal);

export default WorkspaceContext;
